import { LegalPage, LegalSection } from "@/components/LegalPage";
import { CONTACT } from "@/data/site";

const Privacy = () => (
  <LegalPage
    testid="privacy-page"
    overline="GDPR"
    title="Politica de Confidențialitate"
    updated="octombrie 2026"
  >
    <LegalSection title="1. Cine suntem">
      <p>
        Velierul Hope este un serviciu de charter nautic cu velierul Jeanneau
        Sun Odyssey 42.2 „Hope", cu sediul activității în {CONTACT.location},
        județul Constanța. Ne poți contacta oricând la{" "}
        <a href={CONTACT.emailHref} className="text-gold">{CONTACT.email}</a>{" "}
        sau la <a href={CONTACT.phoneHref} className="text-gold">{CONTACT.phone}</a>.
        Datele complete de identificare ale operatorului economic (denumire,
        CUI, sediu social) îți sunt puse la dispoziție la cerere, la aceeași
        adresă de email.
      </p>
    </LegalSection>

    <LegalSection title="2. Ce date colectăm">
      <p>
        Prin formularul de rezervare colectăm: nume și prenume, număr de
        telefon, adresă de email (opțional), experiența dorită, data preferată,
        numărul de persoane și mesajul tău. Nu colectăm date de card — pe acest
        site nu există plăți online.
      </p>
    </LegalSection>

    <LegalSection title="3. De ce le colectăm și pe ce temei">
      <p>
        Datele din formular sunt folosite exclusiv pentru a-ți procesa cererea
        de rezervare și a te contacta cu o ofertă (temei: demersuri la cererea
        ta înainte de încheierea unui contract — art. 6 alin. (1) lit. b din
        GDPR). Cookie-urile de analiză sunt folosite doar cu consimțământul tău
        (art. 6 alin. (1) lit. a).
      </p>
    </LegalSection>

    <LegalSection title="4. Cât timp păstrăm datele">
      <p>
        Cererile de rezervare sunt păstrate maximum 24 de luni, iar
        corespondența aferentă pe durata relației contractuale și a termenelor
        legale de prescripție. După aceste perioade, datele sunt șterse.
      </p>
    </LegalSection>

    <LegalSection title="5. Cu cine împărtășim datele">
      <p>
        Nu vindem și nu cedăm datele tale către terți în scopuri comerciale.
        Datele sunt procesate doar de furnizorii noștri tehnici (găzduire site
        și serviciul de email tranzacțional), cu garanții contractuale de
        confidențialitate.
      </p>
    </LegalSection>

    <LegalSection title="6. Drepturile tale">
      <p>
        Ai dreptul de acces, rectificare, ștergere, restricționare a
        prelucrării, portabilitate și opoziție. Le poți exercita printr-un
        email la <a href={CONTACT.emailHref} className="text-gold">{CONTACT.email}</a>.
        Ai, de asemenea, dreptul de a depune plângere la Autoritatea Națională
        de Supraveghere a Prelucrării Datelor cu Caracter Personal (
        <a href="https://www.dataprotection.ro" target="_blank" rel="noopener noreferrer" className="text-gold">
          www.dataprotection.ro
        </a>
        ).
      </p>
    </LegalSection>
  </LegalPage>
);

export default Privacy;
